'use client';
import LoadingLogo from '@components/Loading/LoadingLogo';
import { useCustomerOrder } from '@hooks/order/useCustomerOrder';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import OrderDetailContent, { OrderDetailProps } from '@views/OrderDetail/OrderDetailContent';
import React from 'react';

export type AccountOrdeDetailProps = Omit<OrderDetailProps, 'order'>;

const AccountOrderDetail = ({ orderHistoryLink, ...rest }: AccountOrdeDetailProps) => {
  const { query, replace } = useCurrentUrl();
  const { data, isLoading } = useCustomerOrder({
    order: query.get('order'),
  });

  React.useEffect(() => {
    if (!query.get('order') || (data && isLoading)) {
      replace(orderHistoryLink.link!);
    }
  }, [data, isLoading, query.get('order'), orderHistoryLink]);

  if (isLoading || !data) {
    return (
      <div className="w-full grid place-content-center py-10">
        <LoadingLogo />
      </div>
    );
  }

  return (
    <OrderDetailContent
      order={data}
      orderHistoryLink={orderHistoryLink}
      isAccountPage
      {...rest}
      trackOrderDetail
    />
  );
};

export default AccountOrderDetail;
